import React from 'react'
import Header from './Components/Header/Header';
import Style from './GlobalStyles';
import {
  HashRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";
import Home from './Pages/Home/Home';
import SkillsPage from './Pages/Skills/SkillsPage';
import Portfolio from './Pages/Portfolio/Portfolio';
import Footer from './Components/Footer/Footer';
import PricesPage from './Pages/Prices/PricesPage';
import ContactsPage from './Pages/Contacts/ContactsPage';

function App() {
  return (
    <Router>
      <Style />
      <Header />
      <Switch>
        <Route path="/" component={Home} exact/>
        <Route path="/home" component={Home} exact/>
        <Route path="/skills" component={SkillsPage} exact/>
        <Route path="/prices" component={PricesPage} exact/>
        <Route path="/portfolio" component={Portfolio} exact/>
        <Route path="/contacts" component={ContactsPage} exact/>
        <Redirect from="*" to="/home" />
      </Switch>
      <Footer />
    </Router>
  );
}

export default App;
